import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
var SelectHardwareTOMForm = observer(function (props) {
    var appStore = props.appStore, hardwareStore = props.hardwareStore, checkAddressStore = props.checkAddressStore, values = props.values, setFieldValue = props.setFieldValue;
    var hardwareCode = values.hardwareCode, hardwareMeshCode = values.hardwareMeshCode;
    var contractCode = props.planStore.planDetails.formValues.contractCode;
    var contract = props.planStore.getContract(contractCode);
    React.useEffect(function () {
        if (contract && contract.planType === 'Bundle') {
            var hardwares = hardwareStore.eligibleModems(contractCode);
            setFieldValue('hardwareCode', hardwares[0].code);
        }
    }, []);
    React.useEffect(function () {
        props.summaryStore.getSummary(props.summaryStore.contractCode, values, props.checkAddressStore.nbnLocId, '', null);
    }, [hardwareCode, hardwareMeshCode]);
    return (React.createElement(Form, null,
        React.createElement(React.Fragment, null,
            React.createElement("section", { className: "row select-hardware" }, hardwareStore.eligibleModems(contractCode).map(function (hardware) { return (React.createElement("label", { htmlFor: hardware.code.toString(), className: "checkbox col-lg-12 grid-pod", key: hardware.code },
                React.createElement("h3", { className: "pod-title" },
                    hardware.name,
                    ' ',
                    contract.planType === 'Monthly' && (React.createElement("span", { className: "price" },
                        "$",
                        (hardware.currentPricing['sellInc'] / 100).toFixed(2))),
                    ' '),
                React.createElement(Field, { type: "radio", name: "hardwareCode", id: hardware.code, value: hardware.code, key: hardware.code, checked: values.hardwareCode === hardware.code, onClick: function () {
                        setFieldValue('hardwareCode', hardware.code);
                        hardwareStore.setDetailsFromForm({
                            hardwareCode: hardware.code,
                        });
                    } }),
                React.createElement("div", { className: "label-hardware pod-image" },
                    React.createElement("img", { src: "/img/hardware/" + hardware.code + ".png", alt: hardware.code, width: "150" })),
                React.createElement("p", { className: "pod-description" }, hardware.description))); })),
            contract && contract.planType === 'Monthly' ? (React.createElement("div", { className: "mb-3" },
                React.createElement("label", { htmlFor: "hardwareCode", className: "checkbox col-12" },
                    React.createElement(Field, { type: "radio", name: "hardwareCode", id: "hardwareCode", value: "", checked: values.hardwareCode === '', onClick: function () {
                            return hardwareStore.setDetailsFromForm({
                                hardwareCode: '',
                            });
                        } }),
                    React.createElement("small", { className: "label" },
                        React.createElement("strong", null,
                            "I already have a",
                            ' ',
                            checkAddressStore.providerCode === 'Uniti'
                                ? 'Fibre'
                                : 'nbn™',
                            ' ',
                            "compatible modem"),
                        React.createElement("br", null),
                        "Please refer to your modem manufacturer and ensure your modem is compatible with the",
                        ' ',
                        checkAddressStore.providerCode === 'Uniti'
                            ? 'Fibre'
                            : 'nbn™',
                        ' ',
                        "technology available at your premises")),
                React.createElement("div", { className: "ml-5 mt-2" },
                    React.createElement("div", { className: "alert alert-info", role: "alert" },
                        React.createElement("p", null, "When switching providers, you may also be required to update your connection settings when switching from another provider."),
                        React.createElement("p", null,
                            "If you switch from another provider and using a BYO modem, we may be limited in performing our standard testing to check if your",
                            ' ',
                            React.createElement("strong", null, checkAddressStore.providerCode === 'Uniti'
                                ? 'fibre'
                                : 'nbn™'),
                            ' ',
                            "service is working properly.",
                            ' '))))) : ('')),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: appStore.previousStep }, "Back"),
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
});
export var SelectHardwareTOM = inject('planStore', 'summaryStore', 'checkAddressStore', 'saleStore', 'hardwareStore', 'appStore')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.hardwareStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var hardwareStore = _a.hardwareStore, planStore = _a.planStore, summaryStore = _a.summaryStore;
        var contractCode = planStore.planDetails.formValues.contractCode;
        var contract = planStore.getContract(contractCode);
        var code = contract.length == 12 ? 'EERO-BUNDLE' : '';
        var hardwares = hardwareStore.eligibleModems(contractCode);
        return hardwares.some(function (h) { return h.code === summaryStore.hardwareCode; })
            ? hardwareStore.hardwareDetails.formValues
            : { hardwareCode: code, hardwareMeshCode: '' };
    },
})(SelectHardwareTOMForm));
//# sourceMappingURL=SelectHardwareTOM.js.map